import { render } from "./CreatePaymentRequestRefund.vue?vue&type=template&id=087b57ef&scoped=true"
import script from "./CreatePaymentRequestRefund.vue?vue&type=script&lang=ts"
export * from "./CreatePaymentRequestRefund.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-087b57ef"

export default script